import { QB_LABEL_TEXT } from './messages'

export const MEMBER_AUTH_ID_MIN_LENGTH = 5

export const QB_MEMBERS_FILTER_OPTIONS = [
  {
    name: QB_LABEL_TEXT.ALL_MEMBERS,
    id: 0
  },
  {
    name: QB_LABEL_TEXT.ALL_TRANSACTIONS,
    id: 1
  }
]

export const QB_MEMBERS_TABLE_FIELDS = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  AUTH_ID: 'AUTH_ID',
  USER_CREATED: 'USER_CREATED'
}

export const QB_TRANSACTIONS_TABLE_FIELDS = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  AUTH_ID: 'AUTH_ID',
  STATUS: 'STATUS',
  DATE_OF_TRANSACTION: 'DATE_OF_TRANSACTION',
  TRANSACTION_HASH: 'TRANSACTION_HASH',
  TRANSACTION_TYPE: 'TRANSACTION_TYPE',
  AMOUNT_OF_CURRENCY: 'AMOUNT_OF_CURRENCY',
  EXCHANGE_CURRENCY: 'EXCHANGE_CURRENCY'
}

export const MEMBER_POINTS_TRANSACTION_TYPES = {
  CREDIT_POINTS: 'credit_points',
  DEBIT_POINTS: 'debit_points'
}
